
























import Component from "vue-class-component";
import Vue from "vue";
@Component({
  components: {},
})
export default class indexPage extends Vue {
  invoiceLine=null;
  merchant=null;
  mounted() {
    this.invoiceLine = this.$route.query.invoiceLine;
    this.merchant = this.$route.query.merchant;
  }
}
